const DATA8 = [
  {
    Term: '2019 Fall',
    Enrolled: 1318,
    Capacity: 1320,
  },
  {
    Term: '2020 Spring',
    Enrolled: 1350,
    Capacity: 1350,
  },
  {
    Term: '2020 Fall',
    Enrolled: 1345,
    Capacity: 1350,
  },
  {
    Term: '2021 Spring',
    Enrolled: 1347,
    Capacity: 1350,
  },
  {
    Term: '2021 Fall',
    Enrolled: 1436,
    Capacity: 1440,
  },
  {
    Term: '2022 Spring',
    Enrolled: 1642,
    Capacity: 1600,
  },
  {
    Term: '2022 Fall',
    Enrolled: 1948,
    Capacity: 1800,
  },
  {
    Term: '2023 Spring',
    Enrolled: 1915,
    Capacity: 1800,
  },
  {
    Term: '2023 Fall',
    Enrolled: 1263,
    Capacity: 1200,
  },
  {
    Term: '2024 Spring',
    Enrolled: 1287,
    Capacity: 1250,
  },
  {
    Term: '2024 Fall',
    Enrolled: 1476,
    Capacity: 1400,
  },
];

const CS61A = [
  {
    Term: '2019 Fall',
    Enrolled: 1828,
    Capacity: 2000,
  },
  {
    Term: '2020 Spring',
    Enrolled: 1137,
    Capacity: 1450,
  },
  {
    Term: '2020 Fall',
    Enrolled: 1751,
    Capacity: 2100,
  },
  {
    Term: '2021 Spring',
    Enrolled: 984,
    Capacity: 1100,
  },
  {
    Term: '2021 Fall',
    Enrolled: 1666,
    Capacity: 1900,
  },
  {
    Term: '2022 Spring',
    Enrolled: 909,
    Capacity: 1058,
  },
  {
    Term: '2022 Fall',
    Enrolled: 1656,
    Capacity: 1900,
  },
  {
    Term: '2023 Spring',
    Enrolled: 1169,
    Capacity: 1345,
  },
  {
    Term: '2023 Fall',
    Enrolled: 1407,
    Capacity: 1775,
  },
  {
    Term: '2024 Spring',
    Enrolled: 872,
    Capacity: 1000,
  },
  {
    Term: '2024 Fall',
    Enrolled: 1240,
    Capacity: 1375,
  },
];

const ENGLISH45A = [
  {
    Term: '2019 Fall',
    Enrolled: 100,
    Capacity: 100,
  },
  {
    Term: '2020 Spring',
    Enrolled: 41,
    Capacity: 41,
  },
  {
    Term: '2020 Fall',
    Enrolled: 67,
    Capacity: 67,
  },
  {
    Term: '2021 Spring',
    Enrolled: 63,
    Capacity: 68,
  },
  {
    Term: '2021 Fall',
    Enrolled: 67,
    Capacity: 68,
  },
  {
    Term: '2022 Spring',
    Enrolled: 67,
    Capacity: 68,
  },
  {
    Term: '2022 Fall',
    Enrolled: 104,
    Capacity: 102,
  },
  {
    Term: '2023 Spring',
    Enrolled: 100,
    Capacity: 102,
  },
  {
    Term: '2023 Fall',
    Enrolled: 136,
    Capacity: 136,
  },
  {
    Term: '2024 Spring',
    Enrolled: 138,
    Capacity: 136,
  },
  {
    Term: '2024 Fall',
    Enrolled: 166,
    Capacity: 170,
  },
];

export default { DATA8, CS61A, ENGLISH45A };
